(function () {
  'use strict';

  var CHECKMARK_SVG =
    '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M2 6L5 9L10 3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  /**
   * Format cents into a currency string using Shopify's money_format pattern.
   * Handles {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}},
   * {{amount_no_decimals_with_comma_separator}}, {{amount_with_apostrophe_separator}}.
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;

    var dollars = (cents / 100).toFixed(2);
    var dollarsWhole = Math.floor(cents / 100);

    function addCommas(n) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function addDots(n) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function addApostrophes(n) {
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    }

    var result = format || '${{amount}}';
    var decimals = dollars.split('.')[1];
    result = result.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, addDots(dollarsWhole) + ',' + decimals);
    result = result.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, addDots(dollarsWhole));
    result = result.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, addApostrophes(dollarsWhole) + '.' + decimals);
    result = result.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, addCommas(dollarsWhole));
    result = result.replace(/\{\{\s*amount\s*\}\}/g, addCommas(dollarsWhole) + '.' + decimals);

    return result;
  }

  function initFreeShippingBar() {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return;

    var tiers = JSON.parse(bar.getAttribute('data-tiers') || '[]');
    if (!tiers.length) return;

    var moneyFormat = bar.getAttribute('data-money-format') || '${{amount}}';
    var achievedColor = bar.getAttribute('data-achieved-color') || '#00800a';
    var currentColor = bar.getAttribute('data-current-color') || '#ffa500';
    var futureColor = bar.getAttribute('data-future-color') || '#cccccc';
    var maxAmount = parseInt(bar.getAttribute('data-free-shipping-max'), 10) || 0;

    var track = bar.querySelector('.free-shipping-bar__track');
    var messagesEl = bar.querySelector('[data-shipping-messages]');
    var achievementsEl = bar.querySelector('[data-shipping-achievements]');
    var markers = bar.querySelectorAll('.free-shipping-bar__marker');

    // --- Full recalculation ---
    function update(cartTotal, itemCount) {
      // Hide if cart is empty
      if (itemCount === 0) {
        bar.classList.add('free-shipping-bar--no-cart');
      } else {
        bar.classList.remove('free-shipping-bar--no-cart');
      }

      // Calculate progress
      var progress = maxAmount > 0 ? Math.min(Math.max(cartTotal / maxAmount, 0), 1) : 0;

      // Find current tier and next tier
      var currentTierIndex = 0; // 1-based (0 = none achieved)
      var nextTier = null;
      var nextTierIdx = -1;

      for (var i = 0; i < tiers.length; i++) {
        if (cartTotal >= tiers[i].amount) {
          currentTierIndex = i + 1;
        }
      }
      for (var j = 0; j < tiers.length; j++) {
        if (cartTotal < tiers[j].amount) {
          nextTier = tiers[j];
          nextTierIdx = j;
          break;
        }
      }

      // Update progress bar fill
      if (track) {
        track.style.setProperty('--progress', progress);
      }

      // Update data attributes
      bar.setAttribute('data-free-shipping-progress', progress);
      bar.setAttribute('data-free-shipping-current-cart', cartTotal);
      bar.setAttribute('data-current-tier', currentTierIndex);

      // Update message
      if (messagesEl) {
        if (nextTier) {
          var amountLeft = nextTier.amount - cartTotal;
          var formatted = formatMoney(amountLeft, moneyFormat);
          messagesEl.innerHTML =
            '<div class="free-shipping-bar__message" data-shipping-message>' +
            '<span class="free-shipping-bar__amount-needed" data-shipping-amount>Spend ' +
            formatted + ' more for </span>' +
            '<span class="free-shipping-bar__goal" data-shipping-goal>' + nextTier.goal + '</span>' +
            '</div>';
        } else {
          messagesEl.innerHTML =
            '<div class="free-shipping-bar__message free-shipping-bar__message--complete" data-shipping-message>' +
            'Free shipping unlocked!' +
            '</div>';
        }
      }

      // Update markers
      markers.forEach(function (marker, i) {
        var tier = tiers[i];
        if (!tier) return;

        var isAchieved = cartTotal >= tier.amount;
        var isCurrent = !isAchieved && nextTierIdx === i;

        // Classes
        marker.classList.toggle('free-shipping-bar__marker--achieved', isAchieved);
        marker.classList.toggle('free-shipping-bar__marker--current', isCurrent);

        // Marker color
        if (isAchieved) {
          marker.style.setProperty('--marker-color', achievedColor);
        } else if (isCurrent) {
          marker.style.setProperty('--marker-color', currentColor);
        } else {
          marker.style.setProperty('--marker-color', futureColor);
        }

        // Dot content (checkmark for achieved)
        var dot = marker.querySelector('.free-shipping-bar__marker-dot');
        if (dot) {
          dot.innerHTML = isAchieved ? CHECKMARK_SVG : '';
        }

        // Tooltip message
        var tooltipMsg = marker.querySelector('.free-shipping-bar__tooltip-message');
        if (tooltipMsg) {
          tooltipMsg.textContent = isAchieved ? tier.success : tier.goal;
        }
      });

      // Update achievements
      if (achievementsEl) {
        if (currentTierIndex > 0) {
          var html = '';
          for (var k = 0; k < currentTierIndex; k++) {
            html += '<div class="free-shipping-bar__achievement"><span>' + tiers[k].success + '</span></div>';
          }
          achievementsEl.innerHTML = html;
          achievementsEl.style.display = '';
        } else {
          achievementsEl.innerHTML = '';
          achievementsEl.style.display = 'none';
        }
      }
    }

    // --- Event listeners ---

    // Cart change: fires after add/remove/quantity change
    document.addEventListener('theme:cart:change', function (event) {
      if (event.detail && event.detail.cart) {
        update(event.detail.cart.total_price, event.detail.cart.item_count);
      }
    });

    // Cart reload: fires when drawer opens after navigation
    document.addEventListener('theme:cart:reload', function () {
      // Fetch fresh cart data since this event doesn't include it
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          update(cart.total_price, cart.item_count);
        })
        .catch(function () {});
    });

    // Drawer open: the bar may be stale if user navigated between pages
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (drawer) {
      drawer.addEventListener('theme:drawer:open', function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            update(cart.total_price, cart.item_count);
          })
          .catch(function () {});
      });
    }

    // --- Mobile tooltip tap handling ---
    document.addEventListener('click', function (e) {
      var marker = e.target.closest('.free-shipping-bar__marker');

      if (marker && window.innerWidth <= 768) {
        e.preventDefault();
        e.stopPropagation();

        // Close other tooltips
        markers.forEach(function (m) {
          if (m !== marker) m.classList.remove('tooltip-active');
        });

        marker.classList.toggle('tooltip-active');
        return;
      }

      // Close all tooltips when clicking outside
      if (!e.target.closest('.free-shipping-bar__marker')) {
        markers.forEach(function (m) {
          m.classList.remove('tooltip-active');
        });
      }
    });

    // Keyboard accessibility
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var marker = e.target.closest('.free-shipping-bar__marker');
        if (marker) {
          e.preventDefault();
          marker.click();
        }
      }
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeShippingBar);
  } else {
    initFreeShippingBar();
  }
})();
